import dateService from '../services/util/dateService'
import loggingService from '../services/util/loggingService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'fileSearchService'
var path = '/FileSearch/'
var isDebug = false

function getUrlById (fileSearchId) {
    return path + fileSearchId
}

function getUrlByObject (fileSearch) {
    return getUrlById(fileSearch.fileSearchId)
}

function get (http, fileSearchId) {
    return http.get(path + 'Get?fileSearchId=' + fileSearchId)
}

function search (http, fileSearchSearchDto) {
    loggingService.log(isDebug, serviceName, 'search')
    return http.post(path + 'Search', fileSearchSearchDto).then(function (response) {
        loggingService.log(isDebug, serviceName, 'search.then')
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
            value.workflowStatusDate = dateService.convertToDate(value.workflowStatusDate)
        })

        return response
    }).catch(error => {
        throw error
    })
}

function todo (http, fileSearchSearchDto) {
    loggingService.log(isDebug, serviceName, 'search')
    return http.post(path + 'Todo', fileSearchSearchDto).then(function (response) {
        loggingService.log(isDebug, serviceName, 'todo.then')
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
            value.workflowStatusDate = dateService.convertToDate(value.workflowStatusDate)
        })

        return response
    })
}

function listShapeFiles (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'listShapeFile')
    return http.get(path + 'ShapeFile?fileSearchId=' + fileSearchId).then(function (response) {
        loggingService.log(isDebug, serviceName, 'listShapeFiles.then')
        return response
    })
}

function put (http, fileSearch) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, fileSearch)
}

function putPlss (http, fileSearchId, plssData) {
    loggingService.log(isDebug, serviceName, 'put plss for fileSearchId' + fileSearchId)

    var data = {
        parentId: fileSearchId,
        parentType: 'FileSearch',
        plssLocation: plssData,
        sections: plssData.Sections
    }

    // return http.put(path + 'PutPlss', plssData).then(function (response) {
    return http.put(path + 'PutPlss', data)
}

function plssLocationList (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'listByFileSearch ' + fileSearchId)
    return http.get(path + 'PlssLocationList?fileSearchId=' + fileSearchId)
}

function calculateBillAmount (http, fileSearchSearchDto) {
    loggingService.log(isDebug, serviceName, 'calculateBillAmount')
    return http.post(path + 'CalculateBillAmount', fileSearchSearchDto).then(function (response) {
        loggingService.log(isDebug, serviceName, 'calculateBillAmount.then')
        return response
    })
}

function deletePlssLocation (http, fileSearchPlssLocationId) {
    loggingService.log(isDebug, serviceName, 'removePlssLocation')
    return http.post(path + 'DeletePlss?fileSearchPlssLocationId=' + fileSearchPlssLocationId)
}

function submitNoCharge (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'submitNoCharge')
    return http.post(path + 'SubmitNoCharge?fileSearchId=' + fileSearchId)
}

function setUser (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'setUser')
    // We determine the userID by the credentials passed to the rest service. We don't pass in an actual user Id
    return http.post(path + 'setUser?fileSearchId=' + fileSearchId)
}

function getFileSearchSitesReport (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'getFileSearchSitesReport')
    return http.get(path + 'GetFileSearchSitesReport?fileSearchId=' + fileSearchId)
}

function getFileSearchProjectsReport (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'getFileSearchProjectsReport')
    return http.get(path + 'GetFileSearchProjectsReport?fileSearchId=' + fileSearchId)
}

function findRelatedFwrE106 (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'FindRelatedFwrE106')
    return http.get(path + 'FindRelatedFwrE106?fileSearchId=' + fileSearchId)
}

function copyE106CompliancePlssLocations (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'CopyE106CompliancePlssLocations')
    return http.put(path + 'CopyE106CompliancePlssLocations?fileSearchId=' + fileSearchId)
}

function copyFieldworkRequestPlssLocations (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'CopyFieldworkRequestPlssLocations')
    return http.put(path + 'CopyFieldworkRequestPlssLocations?fileSearchId=' + fileSearchId)
}

function listCulturalResourceResults (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'listCulturalResourceResults')
    return http.get(path + 'ListCulturalResourceResults?fileSearchId=' + fileSearchId)
}

function updateFileSearchCrInv (http, fileSearchId, siteList, dbiList) {
    loggingService.log(isDebug, serviceName, 'updateFileSearchCrInv')
    var payload = {
        siteSmithNoResults: siteList,
        investigationDbiResults: dbiList
    }
    return http.post(path + 'UpdateFileSearchCrInv?fileSearchId=' + fileSearchId, payload)
}

function deleteFileSearch (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'deleteFileSearch, fileSearchId: ' + fileSearchId)
    return http.get(path + 'deleteFileSearch?fileSearchId=' + fileSearchId)
}

function validatePaymentSubmit (http, fileSearchId) {
    loggingService.log(isDebug, serviceName, 'validatePaymentSubmit')
    return http.post(path + 'ValidatePaymentSubmit?fileSearchId=' + fileSearchId)
}

export default {
    get: get,
    search: search,
    todo: todo,
    put: put,
    calculateBillAmount: calculateBillAmount,
    listShapeFiles: listShapeFiles,
    putPlss: putPlss,
    plssLocationList: plssLocationList,
    deletePlssLocation: deletePlssLocation,
    getUrlById: getUrlById,
    getUrlByObject: getUrlByObject,
    submitNoCharge: submitNoCharge,
    setUser: setUser,
    getFileSearchSitesReport: getFileSearchSitesReport,
    getFileSearchProjectsReport: getFileSearchProjectsReport,
    findRelatedFwrE106: findRelatedFwrE106,
    copyE106CompliancePlssLocations: copyE106CompliancePlssLocations,
    copyFieldworkRequestPlssLocations: copyFieldworkRequestPlssLocations,
    listCulturalResourceResults: listCulturalResourceResults,
    updateFileSearchCrInv: updateFileSearchCrInv,
    deleteFileSearch: deleteFileSearch,
    validatePaymentSubmit: validatePaymentSubmit
}



// WEBPACK FOOTER //
// ./src/services/fileSearchService.js